<!-- Нижнее окно: выезд, свайп вниз, затемнение — SheetDirective -->
<div class="order-dialog-container" [appSheet]="scrollContent" (sheetClosed)="onSheetClosed()">

  <!-- Ручка: окно закрывается свайпом вниз -->
  <div class="sheet-grabber"></div>

  <div class="order-dialog-header">
    <p class="order-title">{{ 'ordersOnThisTable' | translate }}</p>
    <button mat-icon-button class="close-button" (click)="close(); $event.stopPropagation()">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="order-dialog-content" #scrollContent>
    <!-- Аллергия: сообщить официанту (если в меню указаны аллергены) -->
    <app-allergy-notice class="allergy-notice"></app-allergy-notice>

    <!-- Cодержимое вашего заказа -->
    <div *ngIf="foods && foods.length || drinks && drinks.length">
      <div class="order-owner-title" *ngIf="otherGuestsWithItems && otherGuestsWithItems.length">
        <span class="order-owner-title__text">{{ 'yourOrder' | translate }}</span>
        <span class="order-owner-title__line"></span>
        
        <!-- Price of your order -->
        <ng-container *ngIf="getTotalOwner() | priceSeparator as separated">
          <span class="order-owner-title__total">{{ separated.whole }}</span>
          <span class="order-owner-title__total">{{ separated.separator }}</span>
          <span class="order-owner-title__total">{{ separated.fraction }}</span>
        </ng-container>
        <span class="order-owner-title__currency">{{ locale?.currency }}</span>
      </div>

      <app-order-food-card *ngFor="let food of foods; let last = last" [foodOrder]="food"
        [isLast]="last && drinks != null && drinks.length === 0"></app-order-food-card>
      </div>
      <div *ngIf="drinks && drinks.length">
        <app-order-drink-card *ngFor="let drink of drinks; let last = last" [drinkOrder]="drink"
        [isLast]="last"></app-order-drink-card>
    </div>

    <!-- Чужие заказы -->
    <div *ngIf="otherGuestsWithItems && otherGuestsWithItems.length">
      <div *ngFor="let guest of otherGuestsWithItems; let i = index">
        <div class="order-guest-title">
          <span class="order-guest-title__text">{{ 'guest' | translate }} {{ i + 1 }}</span>
          <span class="order-guest-title__line"></span>
          <ng-container *ngIf="getTotalGuest(guest) | priceSeparator as separated">
            <span class="order-guest-title__total">{{ separated.whole }}</span>
            <span class="order-guest-title__total">{{ separated.separator }}</span>
            <span class="order-guest-title__total">{{ separated.fraction }}</span>
          </ng-container>
          <span class="order-guest-title__currency">{{ locale?.currency }}</span>
        </div>

        <app-order-food-card *ngFor="let food of guest.foods; let last = last" [foodOrder]="food"
          [isLast]="last && guest.drinks != null && guest.drinks.length === 0"></app-order-food-card>

        <app-order-drink-card *ngFor="let drink of guest.drinks; let last = last" [drinkOrder]="drink"
          [isLast]="last"></app-order-drink-card>
      </div>
    </div>

    <div class="order-total-title">
      <span class="order-total-title__text">{{ 'total' | translate }}</span>
      <span class="order-total-title__line"></span>
      <ng-container *ngIf="getTotal() | priceSeparator as separated">
        <span class="order-total-title__total">{{ separated.whole }}</span>
        <span class="order-total-title__total">{{ separated.separator }}</span>
        <span class="order-total-title__total">{{ separated.fraction }}</span>
      </ng-container>
      <span class="order-total-title__currency">{{ locale?.currency }}</span>
    </div>

    <!-- Отмена гостем: свои непринятые позиции; ещё не приняли — весь заказ -->
    <div class="order-cancel" *ngIf="canCancel">
      <button mat-button class="order-cancel__button" (click)="cancel(); $event.stopPropagation()">
        {{ (cancelsWholeOrder ? 'cancelOrder' : 'cancelNewItems') | translate }}
      </button>
    </div>

    <div class="order-dialog-footer" *ngIf="restaurant?.payment"></div>
  </div>
</div>
